
import { hasOwnProperty, head } from '@/lib/helpers';
import { gsiOneTapPopup } from '@/lib/utils';
import { ErrorBag } from '@/lib/validator';
import { getLocalKey } from '@/store/local_store';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LoginTnc from './tnc/LoginTnc.vue';
import LoanContainer from './LoanContainer.vue';
@Component({
  components: {
    LoginTnc,
    LoanContainer,
  },
})
export default class PhoneVerification extends Vue {
  @Prop() inviteCodeMessage!: string;
  @Prop() inviteCodeError!: string;
  @Prop() showPhoneNumberScreen!: string;
  @Prop() showOtpScreen!: string;
  @Prop() disabledButton!: boolean;
  @Prop() otpButtonMessage!: string;
  @Prop() errors!: ErrorBag;
  @Prop() isGoogleSigninEnabled!: boolean;
  @Prop() isEmailVerified!: boolean;
  @Prop() isMicroappsEnabled!: boolean;
  @Prop() isSendingOtp!: boolean;
  @Prop() showResendOtp!: boolean;

  private phoneNumber: string = '';
  private inviteCode: string = '';
  private whatsAppOptIn: boolean = true;
  private otpParts: string[] = ['', '', '', ''];
  private otp: string = '';
  private sendingOtpInitiated: boolean = false;

  private get isNewFlowType() {
    return (
      ['NEW', 'NEW_CONTROL'].includes(getLocalKey('QUAL_FLOW_TYPE')) || true
    );
  }

  private mounted() {
    if (!this.isEmailVerified && this.isGoogleSigninEnabled) {
      gsiOneTapPopup((window as any).google);
    }
  }

  private submitInviteCode() {
    this.$emit('submit-invite-code');
  }

  private sendOtp() {
    this.otpParts = [];
    this.sendingOtpInitiated = true;
    this.$emit('send-otp', {
      inviteCode: this.inviteCode,
      phoneNumber: this.phoneNumber,
      whatsAppOptIn: this.whatsAppOptIn,
    });
    this.sendingOtpInitiated = this.isSendingOtp;
  }

  private resetOtpScreen() {
    this.otpParts = [];
    this.$emit('reset-otp-screen');
  }

  private login() {
    this.$emit('login', this.otp);
  }

  private isNumberKey(evt: Event, propertyKey: string) {
    const keyEvent = evt || window.event;
    const charCode = (keyEvent as any).which
      ? (keyEvent as any).which
      : (keyEvent as any).keyCode;
    const character: string = String.fromCharCode(charCode);
    if (
      isNaN(Number(character)) &&
      ![8, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57].includes(charCode)
    ) {
      evt.preventDefault();
      const inputTarget = evt.target;
      if (inputTarget) {
        (inputTarget as any).value = (inputTarget as any).value.replace(
          /[^0-9]/g,
          ''
        );
        (this as any)[propertyKey] = (inputTarget as any).value;
      }
      return false;
    }
    return true;
  }

  private onKeyUpEvent(index: number, event: any) {
    const eventCode = event.which || event.keyCode;
    if (this.otpParts[index] && index <= 3) {
      this.otpParts[index] = this.otpParts[index].slice(
        this.otpParts[index].length - 1
      );
    }
    if (index !== 3) {
      (this.$refs[`otpInput${index + 1}`] as any).focus();
    } else if (eventCode === 13) {
      // this.verifyOtp()
    }
    if (eventCode === 8 && index !== 0) {
      (this.$refs[`otpInput${index - 1}`] as any).focus();
    }
  }

  private onFocusEvent(index: number) {
    for (let item = 0; item < index; item++) {
      if (!this.otpParts[item]) {
        (this.$refs[`otpInput${item}`] as any).focus();
        break;
      }
    }
  }

  private displayError(id: string) {
    if (hasOwnProperty(this.errors, id) && this.errors[id].length > 0) {
      return head(this.errors[id]);
    }
    return '';
  }

  @Watch('otpParts')
  private updateOtp() {
    this.otp = this.otpParts.join('');
  }

  @Watch('otp')
  private triggerAutoOtpSubmit() {
    if (this.otp && this.otp.length === 4) {
      this.login();
    }
  }

  @Watch('phoneNumber')
  private triggerAutoOtpSend() {
    if (
      this.phoneNumber &&
      this.phoneNumber.length === 10 &&
      !this.isSendingOtp &&
      !this.sendingOtpInitiated
    ) {
      this.sendOtp();
    }
  }
}
